export default __webpack_public_path__ + "static/media/image14.8936df57.jfif";